<template>
    <div>
        <div class="content-caption dashed">
            <span>记账基本信息</span>
        </div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label>资产编号</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.innerCode || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>资产名称</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.name || '无' ">{{ shopDevice.name || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>所属公司</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.retailerRealComName || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>公司代码</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.retailerRealComCode || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>利润中心</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.prftCenterCode || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>资产数量</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.fiscalQuantity || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>原值(元)</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.orgWorth == null ? '无' : shopDevice.orgWorth.toFixed(2) }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>净值(元)</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.netWorth == null ? '无' : shopDevice.netWorth.toFixed(2) }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>折旧方式</label>
                </div>
                <div class="form-value">
                    <span>{{ assetDeprMethodMap[shopDevice.deprMethodCode] || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>累计折旧（元）</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.aggtDeprWorth == null ? '无' : shopDevice.aggtDeprWorth.toFixed(2) }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>当月折旧(元)</label>
                </div>
                <div class="form-value">
                    <span v-if="shopDevice.currentMonthDepr != null">{{ (shopDevice.currentMonthDepr).toFixed(2) }}</span>
                    <span v-else>无</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>折旧分摊规则编码</label>
                </div>
                <div class="form-value">
                    <span v-if="shopDevice.deprSpecId != null && shopDevice.deprSpecId != -1"><a class="table-cell-link" @click="showDeprSpec(shopDevice.deprSpecId)">{{ shopDevice.deprSpecCode }}</a></span>
                </div>
            </div>
            <div class="form-group center" v-if="shopDevice.deprMethodCode == 'SLD' || shopDevice.deprMethodCode == 'ASM'">
                <div class="form-label">
                    <label>首次计提</label>
                </div>
                <div class="form-value">
                    <div class="form-value">
                        <span class="font-red" v-if="shopDevice.cnt1stMonth">首月</span>
                        <span v-else>次月</span>
                    </div>
                </div>
            </div>
            <div class="form-group center" v-if="shopDevice.fiscalAcctFlag == 1">
                <div class="form-label">
                    <label>折旧完毕</label>
                </div>
                <div class="form-value">
                    <span class="font-red" v-if="shopDevice.deprOver">是</span>
                    <span v-else>否</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>剩余折旧月数</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.leftMonths || 0 }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>最后折旧月份</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.lastDeprMonth || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>原始资产编号</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.initInnerCode || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>未结算资产</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.outerUnsettled ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>财务异常</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.fiscalAbnormal ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>资产属性</label>
                </div>
                <div class="form-value">
                    <span>{{ assetNatureMap[shopDevice.assetNature] || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>财务类别</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.assetKindName || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>分类编码</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.innerDevcCatCode || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>资产分类</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.innerDevcCatName || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>使用年限（月）</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.durableLife || '无' }}</span>
                </div>
            </div>
            <!--<div class="form-group center">-->
            <!--<div class="form-label">-->
            <!--<label>资产状态</label>-->
            <!--</div>-->
            <!--<div class="form-value">-->
            <!--<div v-if="shopDevice.useState == inactiveValue">-->
            <!--<span class="font-black">未启用</span>-->
            <!--</div>-->
            <!--<div v-else-if="shopDevice.useState == outageValue ">-->
            <!--<span class="font-gold">已停用</span>-->
            <!--</div>-->
            <!--<div v-else-if="shopDevice.useState == startValue">-->
            <!--<span class="font-green">已启用</span>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <div class="form-group center">
                <div class="form-label">
                    <label>资产闲置</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.assetIdleX ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>预定情况</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.reserved ? '已被预定' : '可以预定' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>账面不符</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.indoubtFlag == 1 ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已用年限（月）</label>
                </div>
                <div class="form-value">
                    <!--使用年限（月） - 剩余折旧月数-->
                    <span v-if="shopDevice.fiscalAcctFlag == 0">{{shopDevice.durableYears || 0}}</span>
                    <span v-else-if="shopDevice.deprable">{{(shopDevice.durableLife - shopDevice.leftMonths) || 0}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>入账方式</label>
                </div>
                <div class="form-value">
                    <span>{{ acctEnterWayMap[shopDevice.acctEnterWay] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>含税单价(元)</label>
                </div>
                <div class="form-value">
                    <span v-if="shopDevice.price != null">{{ shopDevice.price.toFixed(2) || 0.00 }}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>未税单价(元)</label>
                </div>
                <div class="form-value">
                    <span v-if="shopDevice.ntxPrice != null">{{ shopDevice.ntxPrice.toFixed(2) || 0.00 }}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>报废数量</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.scrappedQuantity || 0 }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>入账日期</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.fiscalInTime || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>残值率(%)</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.rmnWorthRatio || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>成本中心</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.costCenterCode || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否多部门使用</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.multiDepartUsed ? '是' : '否' }}</span>
                </div>
            </div>
        </div>
        <div v-if="shopDevice.multiDepartUsed">
            <el-table ref="multipleTable" :data="costCenterDeprAllocGroupList" border tooltip-effect="dark" height="400" style="width: 100%">
                <el-table-column align="left" width="120px" prop="allocCostCenterCode" label="成本中心编码" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" width="200px" prop="allocCostCenterName" label="成本中心名称" show-overflow-tooltip></el-table-column>
                <el-table-column align="right" width="180px" prop="allocRatio" label="比例(%)">
                    <template slot-scope="scope">
                        <span>{{ scope.row.allocRatio == null ? null : parseFloat(scope.row.allocRatio).toFixed(2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="allocDepartNames" label="分摊业务部门" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" width="200px" prop="memo" label="备注" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="content-caption dashed">
            <span>资产基础信息</span>
        </div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label>系统编号</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.tmpNo || '无' ">{{ shopDevice.tmpNo || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>外部系统编号</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.innerNo || '无' ">{{ shopDevice.innerNo || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>资产定义编码</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.devcDefNo || '无' ">{{ shopDevice.devcDefNo || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>初始合同编号</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.initContractNo || '无' ">{{ shopDevice.initContractNo || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>供应商名称</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.sellerName || '无' ">{{ shopDevice.sellerName || '无' }}</span>
                </div>
            </div>
            <!--<div class="form-group center">-->
            <!--<div class="form-label">-->
            <!--<label>供应商标识</label>  TODO 无字段-->
            <!--</div>-->
            <!--<div class="form-value">-->
            <!--<span :title="shopDevice.sellerName || '无' ">{{shopDevice.sellerName || '无'}}</span>-->
            <!--</div>-->
            <!--</div>-->
            <div class="form-group center">
                <div class="form-label">
                    <label>资产描述全称</label>
                </div>
                <div class="form-value">
                    <el-tag type="success" v-if="shopDevice.suitMainFlag">主</el-tag>
                    <el-tag type="warning" v-if="shopDevice.tagMissing">缺码</el-tag>
                    <span :title="shopDevice.title || '无' ">{{ shopDevice.title || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>品牌</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.brandName || '无' ">{{ shopDevice.brandName || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>规格</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.fixedSpec || '无' ">{{ shopDevice.fixedSpec || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>型号</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.model || '无' ">{{ shopDevice.model || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>单位</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.theUnit || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>厂商序列号</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.vendorSn || '无' ">{{ shopDevice.vendorSn || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建时间</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.createTime || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>购置日期</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.buyDate || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>导入</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.imported ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>导入记录号</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.importNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收货日期</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.receiveTime }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>验收日期</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.receiptDate }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>批次号</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.batchNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>可拆分</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.splitible ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>清除日期</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.clearDate || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>清除原因</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.clearCause || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>统一商品代码(UPC)</label>
                </div>
                <div class="form-value">
                    <span :title="shopDevice.upc || '无' ">{{ shopDevice.upc || '无' }}</span>
                </div>
            </div>
            <div class="form-group center" v-if="infoType == null || infoType == 'change'">
                <div class="form-label">
                    <label>维保分组</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.devcGroupFullName || '' }}</span>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>设备管理</span>
        </div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label>业务单元</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.retailerBizUnitName || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>部门全称</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.retailerComFullName || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>责任部门</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.respblDepartName || "无" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>责任人</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.respblStaffName || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>领用部门</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.applyUseDepartFullName || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>领用人</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.applyUseStaffName || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>在库数量</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.inStkQuantity }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>在用数量</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.inUseQuantity }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否锁定</label>
                </div>
                <div class="form-value">
                    <span>{{ (shopDevice.fiscalLocked || shopDevice.locked) ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>锁定业务类型</label>
                </div>
                <div class="form-value">
                    <span v-if="shopDevice.fiscalLocked">{{ devcVoucherTypeMap[shopDevice.fiscalLockBizType] }}</span>
                    <span v-else-if="shopDevice.locked">{{ devcVoucherTypeMap[shopDevice.lockBizType] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>锁定单号</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.fiscalLocked ? shopDevice.fiscalLockBizInnerNo : (shopDevice.locked ? shopDevice.lockBizInnerNo : '') }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>报废/弃用</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.scrapped ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>机构编号</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.retailerComNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>标签</label>
                </div>
                <div class="form-value">
                    <template v-for="tagName in shopDevice.tagNames">
                        <span class="swb-tags swb-tags-success mr5">{{ tagName }}</span>
                    </template>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>管理方式</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.assetType == 0 ? "单品式管理" : "批量式管理" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>位置编码</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.locCode }}</span>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>资产图片</span>
        </div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label>资产图片</label>
                </div>
                <div class="form-value">
                    <div class="file-area clearfix" v-if="shopDevice.imageUrl != null && shopDevice.imageUrl.length > 0">
                        <div class="file-item image viewable downloadable">
                            <div class="file-content" @click="viewImage(shopDevice.imageUrl)">
                                <img :src="shopDevice.imageUrl"/>
                                <div class="operation-group">
                                    <i class="icon iconfont icon-chakan view"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <img v-resc-url="'/image/noimg.jpg'"/>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>现场图片</label>
                </div>
                <div class="form-value">
                    <div class="file-area clearfix" v-if="shopDevice.spotImageUrl != null && shopDevice.spotImageUrl.length > 0">
                        <div class="file-item image viewable downloadable">
                            <div class="file-content" @click="viewImage(shopDevice.spotImageUrl)">
                                <img :src="shopDevice.spotImageUrl"/>
                                <div class="operation-group">
                                    <i class="icon iconfont icon-chakan view"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <img v-resc-url="'/image/noimg.jpg'"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-caption dashed" v-if="shopDevice.classifyTagId != null && shopDevice.classifyTagId != -1">
            <span>自定义属性</span>
        </div>
        <!--<swb-prop-editor v-if="shopDevice.classifyTagId != null && shopDevice.classifyTagId != -1" ref="prop_editor" :name="'demo-prop-editor'" :widthForLabel='150' :propList="propList" :viewMode="true"></swb-prop-editor>-->
        <div class="simple-form flex col-4" v-if="shopDevice.classifyTagId != null && shopDevice.classifyTagId != -1">
            <div class="form-group center" v-for="itemInfo in propList">
                <div class="form-label">
                    <label>{{ itemInfo.label }}</label>
                </div>
                <div class="form-value">
                    <template v-if="itemInfo.type != null && itemInfo.type == 'linkUrl'">
                        <!--<a class="swb-btn swb-btn-link" :href="itemInfo.value" target="_blank">{{itemInfo.value}}</a>-->
                        <a class="swb-btn swb-btn-link" @click="viewAsVideo(itemInfo.value)">{{ itemInfo.value }}</a>
                    </template>
                    <span v-else>{{ itemInfo.value || '' }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes, getComnMerchantBizTag} from '../../app.vues'
    import appConf from '../../app.conf';
    import {getDefaultPageSizes} from '../../app.conf'
    import {openBigImgDlg} from '../comn/dialog'
    import {openDeprSpecDetailDlg} from '../devcDef/showDlg'
    import {openVedioPlayerDlg} from '../ctrl/dialog';
    //
    import devcApi from '../../api/devc'
    import shopDevcApi from '../../api/shopDevc'
    import merchtComnApi from '../../api/merchtComn'

    let bizTagObj = null;
    export default {
        name: 'swb-shop-device-asset-info',
        desc: '资产详情',
        props: ['deviceId'],
        data: function () {
            return {
                shopDevice: {},
                startValue: getEnumInfoWith('deviceUseState', 'name', 'Start').value,
                outageValue: getEnumInfoWith('deviceUseState', 'name', 'Outage').value,
                inactiveValue: getEnumInfoWith('deviceUseState', 'name', 'Inactive').value,
                // 入账方式
                acctEnterWayMap: getEnumMap("acctEnterWay", "value2text"),
                devcClearCauseMap: getEnumMap("devcClearCause", "value2text"),
                assetDeprMethodMap: getEnumMap("assetDeprMethod", "name2text"),
                assetNatureMap: getEnumMap("assetNature", "value2text"),
                useMannerMap: getEnumMap("devcUseManner", "value2text"),
                devcVoucherTypeMap: getEnumMap("devcVoucherType", "value2text"),
                //
                propList: [],
                costCenterDeprAllocGroupList: [] // 多成本中心分摊列表
            }
        },
        created: function () {
            bizTagObj = getComnMerchantBizTag();
            //
            this.getDevcCustFieldList();
            this.getshopDevice();
        },
        methods: {
            viewAsVideo(fileBrowseUrl) {
                openVedioPlayerDlg(fileBrowseUrl);
            },
            getshopDevice: function () {
                let self = this;
                let postData = {
                    id: this.deviceId,
                    containMgmt: true,
                    containAsset: true,
                    containMaint: true
                };
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceById(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let shopDevice = result.data;
                        shopDevice = Object.assign(shopDevice, shopDevice.devcMgmtAspkt);
                        shopDevice = Object.assign(shopDevice, shopDevice.devcAssetAspkt);
                        shopDevice = Object.assign(shopDevice, shopDevice.devcMaintAspkt);
                        //
                        if (!Utils.isNoB(shopDevice.bizTag)) {
                            self.makeBizTag(shopDevice);
                        }
                        self.shopDevice = shopDevice;
                        //
                        if (shopDevice.classifyTagId != null && shopDevice.classifyTagId != -1) {
                            self.classifyTagId = shopDevice.classifyTagId;
                            self.classifyTagName = shopDevice.classifyTagName;
                            self.getTagSpecField(function () {
                                self.getDevcCustInfo();
                            });
                        }
                        // 是否多部门使用的时候去查询分摊列表
                        if (Utils.isTrue(shopDevice.multiDepartUsed)) {
                            self.getCostCenterDeprAllocGroupList();
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取分摊列表
            getCostCenterDeprAllocGroupList: function () {
                let self = this;
                let postData = {
                    filterItems: {
                        realComId: self.shopDevice.retailerRealComId,
                        costCenterCodeX: self.shopDevice.costCenterCode
                    }
                };
                merchtComnApi.getCostCenterDeprAllocGroupList(postData, function (result) {
                    if (result.type == 'info') {
                        let costCenterDeprAllocGroupList = result.data || [];
                        self.costCenterDeprAllocGroupList = Utils.merge([], costCenterDeprAllocGroupList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            makeBizTag: function (shopDevice) {
                let bizTag = shopDevice.bizTag;
                let tagIdList = [];
                if (!Utils.isNoB(bizTag)) {
                    if (bizTag.indexOf("|") >= 0) {
                        bizTag = bizTag.substring(1, bizTag.length - 1);
                        tagIdList = bizTag.split("|") || [];
                    } else {
                        tagIdList.push(bizTag);
                    }
                }
                let tagNames = [];
                for (let i = 0; i < tagIdList.length; i++) {
                    let tagId = tagIdList[i];
                    let tagName = bizTagObj.getBizTagNameById(tagId);
                    if (!Utils.isNoB(tagName)) {
                        tagNames.push(tagName);
                    }
                }
                shopDevice.tagNames = tagNames;
            },
            getDevcCustFieldList() {
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcCustFieldList({}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let devcCustFieldList = result.data;
                        self.devcCustFieldList = devcCustFieldList;
                        self.devcCustFieldMap = devcCustFieldList.toMap('id');
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTagSpecField(callback) {
                let self = this;
                let devcCustFieldMap = self.devcCustFieldMap;
                let postData = {};
                postData.classifyTagId = this.classifyTagId;
                //
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcClassifyTagSpecFields(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let tagSpecFieldList = result.data;
                        let propList = [];
                        tagSpecFieldList.forEach(function (tagField) {
                            let field = devcCustFieldMap[tagField.custFieldId];
                            propList.push({
                                label: field.title,
                                code: field.name,
                                valueType: field.type,
                                tooltip: field.desc,
                                required: tagField.required
                            });
                        });
                        self.propList = Utils.merge([], propList);
                        callback();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDevcCustInfo() {
                let self = this;
                let postData = {};
                postData.id = this.shopDevice.id;
                let theLoad = MsgBox.loading();
                shopDevcApi.getDevcCustInfo(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let devcCustInfo = result.data;
                        let custJson = JSON.decode(devcCustInfo.custJson);
                        let propList = self.propList;
                        propList.forEach(function (prop) {
                            if (!Utils.isNoB(custJson[prop.code])) {
                                if (custJson[prop.code].substr(0, 5) == 'http:' || custJson[prop.code].substr(0, 5) == 'https') {
                                    prop.type = 'linkUrl'
                                }
                                prop.value = custJson[prop.code];
                            }
                        });
                        self.propList = Utils.merge([], propList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
            showDeprSpec(deprSpecId) {
                openDeprSpecDetailDlg(deprSpecId);
            }
        }
    }
</script>

<style>
    .form-row.col .form-label {
        width: 126px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/devc/ShopDeviceAssetInfo.vue